import { Form as FormikForm } from "formik"

import {
    L2RButton,
    FormikAutoCompleteWithChips,
    Skeleton as UiSkeleton,
    Typography as UiTypography,
    styled,
} from "@l2r-front/l2r-ui"


export const Button = styled(L2RButton)({
    textTransform: "none",
})

export const SubmitButton = styled(L2RButton)(({ theme }) => ({
    marginLeft: theme.spacing(2),
    textTransform: "capitalize",
}))

export const ButtonsWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    padding: theme.spacing(4, 0, 0, 0),
}))

export const Wrapper = styled("div")({
    display: "flex",
    marginLeft: "auto",
})

export const InputsWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: theme.spacing(3),
}))

export const AutoCompleteFilter = styled(FormikAutoCompleteWithChips)(() => ({
    width: "100%",

    "& .MuiAutocomplete-popupIndicator": {
        transform: "none",
    },
}))

export const FormWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(8, 4),
}))

export const Skeleton = styled(UiSkeleton)(({ theme }) => ({
    height: "172.5px",
    margin: theme.spacing(8, 4),
    transform: "scale(1)",
    width: "auto",
}))

export const Error = styled(UiTypography)(({ theme }) => ({
    color: theme.palette["error"].main,
    margin: theme.spacing(8, 4),
    textAlign: "center",
    width: "auto",
}))

export const Form = styled(FormikForm)(() => ({
    height: "100%",
    display: "flex",
    flexDirection: "column",
}))